import { Theme } from "@mui/material";

import makeStyles from "@mui/styles/makeStyles";

const styles = makeStyles((theme: Theme) => ({
  container: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    height: "100%",
    width: "100%",
    background: "#EDF5FB",
    borderRadius: "15px",
  },
  identity: {
    padding: "6px 8px",
    background: "rgba(255, 255, 255, 0.7)",
    backdropFilter: "blur(4px)",
    borderRadius: "8px",
  },
  infoContainer: {
    position: "absolute",
    zIndex: 2,
    height: "100%",
    width: "100%",
  },
  infoContainerHeader: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: "9px",
    width: "100%",
  },
  infoContainerFooter: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    alignItems: "center",
    justifyContent: "center",
    padding: "9px 9px 16px 9px",
    gap: "12px",
  },
  reconnectingContainer: {
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "15px",
    background: "rgba(40, 42, 43, 0.75)",
    zIndex: 1,
  },
  fullWidth: {
    gridArea: "1 / 1 / 2 / 3",
    [theme.breakpoints.down("sm")]: {
      gridArea: "1 / 1 / 3 / 3",
    },
  },
  avatarContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    height: "90px",
    width: "90px",
    background: "#465869",
    borderRadius: "50%",
    "& svg": {
      height: "40px",
      width: "40px",
    },
  },
  recordTime: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    padding: "4px 8px",
    borderRadius: "8px",
    background: "rgba(255, 255, 255, 0.7)",
    backdropFilter: "blur(4px)",
    marginLeft: "30px",
  },
  timeText: {
    color: "#465869",
    fontFamily: "Manrope",
    fontWeight: 400,
    fontSize: "16px",
  },
  infoContainerContent: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "center",
    height: "100%",
  },
  screenshotButton: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    height: "54px",
    width: "54px",
    background: "#465869",
    borderRadius: "50%",
    "& svg": {
      height: "22px",
      width: "22px",
    },
  },
  recordIcon: {
    height: "11px",
    width: "11px",
    marginRight: "4px",
  },
}));

export default styles;
